module.exports = __webpack_public_path__ + "static/media/1014972.62284825.jpg";